export default __webpack_public_path__ + "static/media/app_embed_enable_switch.6ad2ad5c.png";